var map = {
	"./ic_accident_bl.svg": "c527",
	"./ic_analytic.svg": "56c5",
	"./ic_analytic_wh.svg": "f411",
	"./ic_area.svg": "edce",
	"./ic_area_wh.svg": "3070",
	"./ic_die_bl.svg": "8e62",
	"./ic_injury_bl.svg": "eac9",
	"./ic_klong.svg": "059c",
	"./ic_layers.svg": "3619",
	"./ic_many_point.svg": "a47b",
	"./ic_many_point_wh.svg": "de13",
	"./ic_point.svg": "944c",
	"./ic_point_wh.svg": "3489",
	"./ic_river.svg": "89b3",
	"./ic_sea.svg": "bf84"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "12db";